"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_client_1 = require("vue-cli-plugin-apollo/graphql-client");
const utils_1 = require("../utils");
function makeApolloClient(providerName = 'default') {
    const AUTH_TOKEN = 'accessToken';
    const httpEndpoint = utils_1.config(providerName).httpEndpoint || process.env.VUE_APP_GRAPHQL_HTTP;
    const wsEndpoint = utils_1.config(providerName).wsEndpoint || process.env.VUE_APP_GRAPHQL_WS;
    let apolloClient;
    let wsClient;
    if (httpEndpoint) {
        ({ apolloClient, wsClient } = graphql_client_1.createApolloClient({
            httpEndpoint,
            ...(wsEndpoint ? {
                wsEndpoint,
            } : {}),
            websocketsOnly: false,
            tokenName: AUTH_TOKEN,
            connectToDevTools: process.env.NODE_ENV !== 'production',
            apollo: {
                defaultOptions: {
                    watchQuery: {
                        fetchPolicy: 'no-cache',
                        errorPolicy: 'ignore',
                    },
                    query: {
                        fetchPolicy: 'no-cache',
                        errorPolicy: 'all',
                    },
                }
            }
        }));
        if (wsClient) {
            apolloClient.wsClient = wsClient;
        }
    }
    return apolloClient;
}
exports.default = makeApolloClient;
//# sourceMappingURL=makeApolloClient.js.map